<template>
  <div
    class="card"
    :class="{ active: obj.title != 'Licencias' ? true : false }"
  >
    <img :src="obj.icon" alt="imagen" v-if="obj.icon && !esTramite" />

    <h2 class="h2-hero width" :style="{ color: color }">{{ obj.title }}</h2>
    <p class="p-small descripcion" v-if="mostrarDescripcion">
      {{ obj.short_description }}
    </p>
  </div>
</template>
<script>
export default {
  name: "CardCategorias",
  props: {
    obj: Object,
    color: String,
    mostrarDescripcion: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      esMobile: window.innerWidth <= 990,
    };
  },
  mounted() {
    window.addEventListener("resize", this.actualizarEsMobile);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.actualizarEsMobile);
  },
  methods: {
    actualizarEsMobile() {
      this.esMobile = window.innerWidth <= 990;
    },
  },
  computed: {
    esTramite() {
      return !!(this.obj.area || this.obj.SLA);
    },
  },
};
</script>
<style scoped>
.card {
  width: 15.227vw;
  min-height: 22.037vh;
  border-radius: 0.5rem;
  margin: auto;
  text-align: center;
  transition: border 0.1s ease;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--gap10);
  border: none;
  cursor: pointer;
  background: var(--card-secondary);
  padding: 10px;
  box-shadow: 0px 4px 12px 0px rgba(62, 62, 62, 0.25);

  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease,
    background 0.25s ease,
    border 0.01s ease;
}
img {
  transition: transform 0.1s ease-in-out;
}
.card img {
  width: 4.026vw;
  height: 9.182vh;
}
.card:hover {
  border: 2px solid transparent;
}
[data-theme="light"] .card:hover {
  background:
    linear-gradient(#fff, #fff) padding-box,
    var(--verdeGradient) border-box;
}

[data-theme="dark"] .card:hover {
  border: 1px solid var(--color-success);
}
h2 {
  width: 100%;
  color: var(--text-primary);
}
/* .width {
  max-width: 10.249vw;
} */
.descripcion {
  width: 11.713vw;
  color: var(--text-primary);
}
@media (max-width: 990px) {
  .width {
    width: 100%;
    max-width: unset;
  }
  .card {
    width: 28vw;
  }
  .descripcion {
    display: none;
  }
}
@media (max-width: 770px) {
  .card:hover {
    background: transparent;
  }
  .card {
    width: 42vw;
    min-height: 16.66vh;
    border-radius: 0.5rem;
    margin: auto;
    text-align: center;
    transition: border 0.1s ease;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--gap5);
    padding: var(--gap10) var(--gapHM10);
    border: none;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);

    transition: none;
  }
  .card h2 {
    color: var(--text-primary);
  }
  .card img {
    height: var(--margin40);
    width: var(--gapHM40);
  }
  img {
    transition: transform 0.1s ease-in-out;
  }
  .descripcion {
    display: none;
  }
  .width {
    width: 100%;
    max-width: unset;
  }
}

@media (max-width: 460px) {
  .card {
    width: 41.6vw;
    height: 140px;
    min-height: unset;
  }
  .descripcion {
    display: block;
    width: 100%;
  }

  .card img {
    display: block;
    max-width: 80px;
    height: auto;
  }
  img {
    transition: transform 0.1s ease-in-out;
  }
}
</style>
